import 'zdocs-web-core/theme/modern-reset.css';
import 'zdocs-web-core/theme/zdocs-reset.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { ErrorBoundary } from '~/core/lib/error';
import { rumInit } from 'zdocs-web-core/lib/rum';
import { Service } from 'zdocs-web-core/lib/constants';
import { getTokenFromUrl } from 'zdocs-web-core/lib/doc-editor';
import { getBrandOptions, brandInit } from '~/core/components/BrandProvider';
import App from './App';

function getTokenInfo() {
  try {
    return getTokenFromUrl();
  } catch {}
}

export default function init() {
  const tokenInfo = getTokenInfo();
  rumInit(Service.StandaloneEditor, tokenInfo);

  const brand = getBrandOptions();
  brandInit(brand);

  ReactDOM.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
    document.getElementById('root')
  );
}
